module.exports = __webpack_public_path__ + "static/media/bills-uploadInvoice.b2dd971e.svg";